import { getUrlWithQueryParams } from '@helpers/productWidgetHelper'

export const getAbhaJourneyUrl = (phone, aadhar) => getUrlWithQueryParams(`/gi/p/health/newAbha?phone=${phone}&aadhar=${aadhar}`)
